import React, { useEffect, useState } from 'react';
import VendorProgramList from '../vendor-program/vendor-program-list';
import { useVendorPointSolutionContext } from '../vendor-solution-provider';
import { camelCase, mapKeys } from 'lodash';

const VendorSolutionSettingContainer = props => {
  const { vendorPrograms, entityType, organizationId, hasBillingAccess} = props
  const [vendorProgramList, setVendorProgramList] = useState([]);
  const isGroup = entityType === 'group';
  const {
    vendorPoints,
    categories
  } = useVendorPointSolutionContext();

  useEffect(() => {
    const updatedVendorProgramList = vendorPrograms.map(vendorProgram => {
        const updatedVendorProgram = mapKeys(vendorProgram, (v, k) => camelCase(k));

        return {
          ...updatedVendorProgram,
          isExcluded: false,
          isInherited: updatedVendorProgram.organizationId != organizationId
        };
      }
    );

    setVendorProgramList(updatedVendorProgramList);
  }, []);

  const handleEditVendorProgram = (values, vendorProgram) => {
    const { categoryCode, vendorId } = values;
    const { category, vendor } = getCategoryAndVendor(categoryCode, vendorId);

    const updatedVendorProgram = {
      ...vendorProgram,
      ...values,
      categoryName: category.name,
      vendorName: vendor.vendorNm
    };

    const updatedVendorPrograms = vendorProgramList.map(item => {
        if (item.vendorProgramId === vendorProgram.vendorProgramId) return updatedVendorProgram;
        return item;
      }
    );
    setVendorProgramList(updatedVendorPrograms);
  };

  const handleDeleteVendorProgram = vendorProgram => {
    const isConfirm = window.confirm('Please confirm you want to delete this vendor program?');
    if (isConfirm) {
      const updatedVendorPrograms = vendorProgramList.map(item => {
        if (item.vendorProgramId !== vendorProgram.vendorProgramId) return item;

        return {
          ...item,
          isExcluded: true
        };
      });

      setVendorProgramList(updatedVendorPrograms);
    }
  };

  const handleCreateVendorProgram = values => {
    const { categoryCode, vendorId } = values;
    const { category, vendor } = getCategoryAndVendor(categoryCode, vendorId);

    const vendorProgram = {
      ...values,
      categoryName: category.name,
      vendorName: vendor.vendorNm,
      vendorProgramId: Date.now().toString(36),
      isExcluded: false,
      isInherited: false,
      organizationId: organizationId
    };

    setVendorProgramList([...vendorProgramList, vendorProgram]);
  };

  const getCategoryAndVendor = (categoryCode, vendorId) => {
    const category = categories.find(category => category.masterCodeCd === categoryCode);
    const vendor = vendorPoints.find(vendor => vendor.vendorId.toString() === vendorId);
    return { category, vendor };
  };

  return (
    <VendorProgramList
      vendorPrograms={vendorProgramList}
      onCreateVendorProgram={handleCreateVendorProgram}
      onEditVendorProgram={handleEditVendorProgram}
      onDeleteVendorProgram={handleDeleteVendorProgram}
      isGroup={isGroup}
      isSetting={true}
      hasBillingAccess={hasBillingAccess}
    />
  );
};

export default VendorSolutionSettingContainer;
